/** Case- AND accent-insensitive folding for catalog search: "cable" must
 *  match "Câble", "emetteur" → "Émetteur". NFD split + strip combining marks. */
export function foldSearch(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
